import { render, staticRenderFns } from "./ToolsPanel.vue?vue&type=template&id=5ab0f444&scoped=true&"
import script from "./ToolsPanel.vue?vue&type=script&lang=js&"
export * from "./ToolsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0f444",
  null
  
)

export default component.exports